var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_35)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5058 12.3602L11.5048 6.81417L19.3403 9.59676L11.5058 12.3602ZM28.71 5.85312C28.71 5.85312 28.4263 4.49298 27.5573 3.89402C26.4543 3.10755 25.2182 3.10384 24.6518 3.05819C20.5936 2.85833 14.5063 2.85834 14.5063 2.85834H14.4937C14.4937 2.85834 8.40638 2.85833 4.34819 3.05819C3.78088 3.10384 2.54566 3.10755 1.44185 3.89402C0.572753 4.49298 0.289997 5.85312 0.289997 5.85312C0.289997 5.85312 0 7.45075 0 9.04776V10.5455C0 12.1431 0.289997 13.7401 0.289997 13.7401C0.289997 13.7401 0.572753 15.1002 1.44185 15.6992C2.54566 16.4857 3.99475 16.461 4.64 16.543C6.96 16.6948 14.5 16.7417 14.5 16.7417C14.5 16.7417 20.5936 16.7355 24.6518 16.5356C25.2182 16.4894 26.4543 16.4857 27.5573 15.6992C28.4263 15.1002 28.71 13.7401 28.71 13.7401C28.71 13.7401 29 12.1431 29 10.5455V9.04776C29 7.45075 28.71 5.85312 28.71 5.85312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 19.6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d47a1c8f4efdca4ab301527e747f8720.svg";
export { ForwardRef as ReactComponent };